import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useManualSetupDefault } from "@/hooks/useManualSetupDefault";
import { useDisplayTwoFactorAuthenticationData } from "@/services/auth";

import { TwoFactorChangeAuthQRCode } from "./TwoFactorChangeAuthQRCode";
import { TwoFactorManualQrCodeField } from "./TwoFactorManualQrCodeField";

// This component displays the current QR code again
// for users in their 2FA management page.
export const TwoFactorQRCodeSection = () => {
  const { t } = useTranslation();
  const { mutate, data } = useDisplayTwoFactorAuthenticationData();
  const [showManualSetup, setShowManualSetup] = useManualSetupDefault();

  useEffect(() => {
    mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-body-base font-semibold text-foreground-primary">
        {t("portal:user-account.security.2fa.qrCode.title")}
      </p>
      <div className="flex flex-col items-center gap-4 text-center">
        <p className="text-base text-foreground-primary">
          {t("portal:user-account.security.2fa.qrCode.description")}
        </p>
        {showManualSetup ? (
          <div className="flex w-full flex-col items-center gap-2">
            <TwoFactorManualQrCodeField manualCode={data?.manualCode} />
            <button
              type="button"
              className="text-center text-body-sm font-semibold text-foreground-primary underline"
              onClick={() => setShowManualSetup(false)}
            >
              {t("portal:authenticator.app.setup.step1.back-to-qr-code")}
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-2">
            <TwoFactorChangeAuthQRCode qrCodeData={data?.qrCodeUri} />
            <button
              type="button"
              className="text-center text-body-sm font-semibold text-foreground-primary underline"
              onClick={() => setShowManualSetup(true)}
            >
              {t("portal:authenticator.app.setup.step1.enter-key-manually")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
